import { render, staticRenderFns } from "./ShowGnbReportTemplateDetail.vue?vue&type=template&id=6a93dd8e&scoped=true&"
import script from "./ShowGnbReportTemplateDetail.vue?vue&type=script&lang=js&"
export * from "./ShowGnbReportTemplateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a93dd8e",
  null
  
)

export default component.exports